import React from 'react';
import { motion } from 'framer-motion';
import { XCircle } from 'lucide-react';
export function PainSection() {
  const painPoints = ['Te levantas por la mañana ya cansada, como si el sueño no hubiera servido de nada.', 'Te miras al espejo y ves una cintura que antes no estaba ahí... y que no baja sin importar lo que hagas.', "Comes 'bien' durante días enteros, te matas en el gym... y la báscula no se mueve ni un gramo.", 'A las 3 de la tarde sientes un antojo de dulce tan intenso que parece imposible de controlar.', 'Tu ropa favorita de hace dos años está guardada en el clóset porque ya no cierra igual.', "Te has dicho: 'Antes con solo cerrar la boca bajaba. Ahora nada funciona.'"];
  return <section className="w-full bg-white py-16 px-4" data-id="element-246">
      <div className="max-w-[760px] mx-auto" data-id="element-247">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-[28px] font-bold text-teal text-center mb-10" data-id="element-248">
          ¿Te suena familiar alguna de estas situaciones?
        </motion.h2>

        <div className="flex flex-col" data-id="element-249">
          {painPoints.map((point, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="flex items-start gap-4 py-4 border-b border-[#F0F0F0] hover:bg-teal/5 transition-colors rounded-lg px-2" data-id="element-250">
              <div className="mt-0.5 flex-shrink-0" data-id="element-251">
                <XCircle className="text-orange w-6 h-6" data-id="element-252" />
              </div>
              <p className="text-[17px] text-dark leading-[1.6]" data-id="element-253">{point}</p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.4
      }} className="mt-10 bg-orange-light border-l-4 border-orange rounded-lg p-6 md:p-7" data-id="element-254">
          <p className="text-[20px] italic text-orange font-medium mb-3" data-id="element-255">
            "Si asentiste con la cabeza aunque sea una vez... Necesitas leer
            cada palabra de esta página."
          </p>
          <p className="text-[16px] text-dark/80" data-id="element-256">
            Porque lo que te está pasando no es falta de voluntad. Es fisiología
            pura. Y tiene nombre.
          </p>
        </motion.div>
      </div>
    </section>;
}